import { create } from 'zustand'
interface State {
    progressSchedule: number
    setProgressSchedule: (progress: number) => void
    isVisibleProgressSchedule: boolean
    setIsVisibleProgressSchedule: (isVisible: boolean) => void
    resetProgressSchedule: () => void
}

/* 
    1)Busca la version de agenda si tiene que descargar  0 a 14%
    2)Descarga 1 Zip 14 a 28%
    3)Descomprime un Zip 28 a 42%
    4)Inserto 42 a 57 progresivo%
    5)Descarga 2 Zip  de 57 a 71%
    6)Descomprime el otro 71 a 85%
    7)Inserto de 85 a 93 progresivo %
    8)Formularios 93 a 100 progresivo%
*/

export const PROGRESS_STEPS = {
    STEP_1: { start: 0, end: 10, progresive: false }, // Busca la version de agenda si tiene que descargar
    STEP_8: { start: 10, end: 18, progresive: true }, //// Formularios
    STEP_2: { start: 18, end: 28, progresive: false }, // Descarga 1 Zip
    STEP_3: { start: 28, end: 42, progresive: false }, // Descomprime
    STEP_4: { start: 42, end: 57, progresive: true }, // Inserto
    STEP_5: { start: 57, end: 71, progresive: false }, // Descarga 2 Zip
    STEP_6: { start: 71, end: 85, progresive: false }, // Descomprime
    STEP_7: { start: 85, end: 99, progresive: true }, // Inserto
    STEP_9: { start: 99, end: 100, progresive: true }, //
}

export const useProgressSchedule = create<State>((set, get) => ({
    isVisibleProgressSchedule: false,
    progressSchedule: 0,
    setProgressSchedule: (progressSchedule) => {
        if (progressSchedule >= get().progressSchedule && progressSchedule <= PROGRESS_STEPS.STEP_9.end) {
            set({ progressSchedule })
        }
    },
    setIsVisibleProgressSchedule: (isVisibleProgressSchedule) => set({ isVisibleProgressSchedule }),
    resetProgressSchedule: () => set({ progressSchedule: 0 }),
}))
